import { render, staticRenderFns } from "./NewsPlayer.vue?vue&type=template&id=82492d90&scoped=true&"
import script from "./NewsPlayer.vue?vue&type=script&lang=js&"
export * from "./NewsPlayer.vue?vue&type=script&lang=js&"
import style0 from "./NewsPlayer.vue?vue&type=style&index=0&id=82492d90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82492d90",
  null
  
)

export default component.exports